import { CONSIGNMENT_PERMS } from '@mlm/shared';
import {
  ExportButtons as SharedExportButtons,
  type ExportButtonsProps,
} from '@mlm/ui/components/export-buttons';
import { useHasPerm } from '../lib/auth-store';

/**
 * The cashier's binding of the shared `ExportButtons`.
 *
 * The component itself lives in `@mlm/ui` (subpath-only, so jsPDF and the zip
 * writer stay in async chunks) and owns no perm codes; this wires it to the
 * till's auth store and the Consignment perms once, so the Consignment tabs
 * keep calling `<ExportButtons table={…} />` unchanged.
 *
 * `useHasPerm` is passed as a module-level function on purpose — it is invoked
 * as a hook inside the shared component, so its identity must be stable.
 */
/**
 * Both file formats ride the SAME `consignment.export` code. The admin's
 * per-format `export.excel` / `export.pdf` split deliberately stops at the
 * cashier: a tenant that already unchecked "Export" for a till role must not be
 * silently re-opened, and re-gating these tabs would double-gate them.
 */
const PERMS = {
  excel: CONSIGNMENT_PERMS.export,
  pdf: CONSIGNMENT_PERMS.export,
  print: CONSIGNMENT_PERMS.print,
};

export function ExportButtons(props: Omit<ExportButtonsProps, 'perms' | 'useHasPerm'>) {
  return <SharedExportButtons {...props} perms={PERMS} useHasPerm={useHasPerm} />;
}
